import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import autobind from "class-autobind"
import { IJobPhase } from "../../models"
import AddPhaseDialogForChip from "./AddPhaseDialogForChip"
import { grey500, grey700, green500, red500 } from "material-ui/styles/colors"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import { checkPhaseFieldAvailable } from "../../helpers/punchHelper"
interface IProps {
	label: string
	maxWidth?: number
	phases: IJobPhase[]
	disabled?: boolean
	selectedPhase?: IJobPhase
	handleSave(phase: IJobPhase): void

	//Employee->Timecard->PunchDrawerTable
	isPunchListTable?: boolean
	phaseColWidth?: number
}
interface IState {
	selectedPhase: IJobPhase
	openChooseDialog: boolean
}

export default class PhasesChip extends React.Component<IProps, IState>  {
	constructor(props) {
		super(props)
		this.state = {
			selectedPhase: props.selectedPhase,
			openChooseDialog: false,
		}
		autobind(this)
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ selectedPhase: nextProps.selectedPhase })
	}

	render() {
		const deletedPhase = this.state.selectedPhase && (!this.state.selectedPhase.Active || this.state.selectedPhase.Deleted)
		return (
			<div>
				<div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.298)" }}>
					{this.props.disabled && !this.props.selectedPhase ?
						null :
						this.props.label ?
							this.props.label :
							null
					}
				</div>
				{this.state.selectedPhase &&
					<Chip
						data-intercom-target={"Select-Phase"}
						style={{ justifyContent: this.props.isPunchListTable && "space-between", margin: 2, height: 35, width: this.props.isPunchListTable ? this.props.phaseColWidth : "min-content" }}
						onRequestDelete={this.props.disabled ?
							null :
							() => {
								this.setState({ selectedPhase: null })
								this.props.handleSave(null)
							}}
					>
						<div
							className="TextOverflow"
							title={this.state.selectedPhase.Name}
							style={{
								maxWidth: this.props.isPunchListTable ? this.props.phaseColWidth - 50 : this.props.maxWidth ? this.props.disabled ? this.props.maxWidth : this.props.maxWidth - 25 : 150,
								color: deletedPhase ? red500 : this.state.selectedPhase.Id === AccountStore.DiffPhaseId && green500,
								fontSize: this.props.isPunchListTable && 12
							}}
						>
							{deletedPhase ?  (checkPhaseFieldAvailable("singular") ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel} Removed` : strings.Phase_Removed) : this.state.selectedPhase.Name}
						</div>
					</Chip>
				}
				{!this.props.disabled && !this.state.selectedPhase &&
					<IconButton
						data-intercom-target={"Phase-Btn-OpenPhaseSelectionDialog"}
						//style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
						style={{ height: this.props.isPunchListTable ? 18 : 35, width: this.props.isPunchListTable ? 18 : 35, marginTop: this.props.isPunchListTable && 10, padding: 0, margin: 0, display: "inline-block" }}
						iconStyle={{ color: this.props.isPunchListTable ? grey500 : grey700, fontSize: this.props.isPunchListTable ? 18 : 24 }}
						onTouchTap={() => this.setState({ openChooseDialog: true })}
					>
						<FontIcon className="fa fa-plus-circle" />
					</IconButton>
				}
				{this.state.openChooseDialog &&
					<AddPhaseDialogForChip
						phases={this.props.phases.filter(i => !i.Deleted && i.Active)}
						handleClose={() => this.setState({ openChooseDialog: false })}
						handleSave={selectedPhase => {
							this.setState({
								selectedPhase,
								openChooseDialog: false
							})
							this.props.handleSave(selectedPhase)
						}}
					/>
				}
			</div>
		)
	}
}
